import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/sites/'
const ITEM_ID  = 'sit_id'

export const useSiteStore = defineStore('sites', {
  // convert to a function
  state: () => ({
    item: { 
        sit_name: '',
        sit_uid: '',
        sit_address: '',
        sit_zip: '',
        sit_town: '',
        sit_lat: null,
        sit_lng: null,
        sit_sta_id: 'GEN01', sit_typ_id: 'SIT01', sit_customfields : {}
    },
    itemList: [],
    metaItems: null
  }),
  getters: {

  },
  actions: {
    fetchItem (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id > 0 ){
                ApiService.get(ENDPOINT + id + options).then( (response) => {
                    if( !response.data.data.sit_customfields || Object.prototype.toString.call( response.data.data.sit_customfields ) === '[object Array]' ) {
                        response.data.data.sit_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItemByNfc (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id.length > 0 ){
                ApiService.get(ENDPOINT + 'nfc/' + id + options).then( (response) => {
                    if( !response.data.data.sit_customfields || Object.prototype.toString.call( response.data.data.sit_customfields ) === '[object Array]' ) {
                        response.data.data.sit_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItems (options) {
        return new Promise( (resolve, reject) => {
            this.SET_ITEMS([])
            options = (options) ? options : ''
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.metaItems = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.SET_ITEMS(response.data.data)
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    storeItem () {
        return new Promise( (resolve, reject) => {
            ApiService.post( ENDPOINT, this.item ).then( (response) => {
                this.SET_ITEM(response.data.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    updateItem () {
        return new Promise( (resolve, reject) => {
            ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
                this.SET_ITEM(response.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    destroyItem (id) {
        return new Promise( (resolve, reject) => {
            this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
            ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
                this.RESET_ITEM()
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
    },
    SET_ITEMS (itemList) {
      this.itemList = itemList
    },
    RESET_ITEM () {
      this.item = {
        sit_uid: '',
        sit_name: '',
        sit_address: '',
        sit_zip: '',
        sit_town: '',
        sit_lat: null,
        sit_lng: null,
        sit_sta_id: 'GEN01', sit_typ_id: 'SIT01', sit_customfields : {} }
    }
  }
})
